import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

import DisplayNames from './enums';

export type PageHeaderLeftElementProps = BoxProps;

const PageHeaderLeftElement = (props: PageHeaderLeftElementProps): React.ReactElement => {
  return <Box {...props} />;
};

PageHeaderLeftElement.propTypes = {};
PageHeaderLeftElement.displayName = DisplayNames.PageHeaderLeftElement;

export default PageHeaderLeftElement;
